import SchoolsPartners from "./SchoolsPartners";

export default SchoolsPartners;
